import { styled } from '@mui/material';

export const HBChartRootStyle = styled('div')(({}) => {
  return {};
});
